<template>
  <div>
    <span v-if="option.qty > 1">{{ option.qty }}x</span>
    <span class="option-label">{{ optionNameValue }} </span>
    <span class="option-value">{{ option.title }}</span>
    <span class="option-price">{{ option.price | price }}</span>
  </div>
</template>
<script>
  export default {
    name: 'CustomOption',
    props: {
      option: {
        type: Object,
        required: true
      },
      displayName: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    computed: {
      optionNameValue () {
        return this.displayName ? `${this.option.name}:` : ''
      }
    }
  }
</script>
